import * as React from "react";
import { HStack, Radio, RadioGroup, Text } from "@chakra-ui/react";

export type ContactFilterValue = "individual" | "organization";

type ContactFilterProps = {
  value: ContactFilterValue;
  onChange: (value: ContactFilterValue) => void;
  isdisabled?: boolean | undefined;
};

export const ContactFilter: React.FC<ContactFilterProps> = ({
  value,
  onChange,
  isdisabled = false,
}) => {
  return (
    <RadioGroup
      value={value}
      onChange={(val) => onChange(val as ContactFilterValue)} 
    >
      <HStack spacing="6">
        <Radio value="individual" colorScheme="primary" isDisabled={isdisabled}>
          <Text fontWeight="medium">Individual</Text>
        </Radio>

        <Radio value="organization" colorScheme="primary" isDisabled={isdisabled}>
          <Text fontWeight="medium">Organization</Text>
        </Radio>
      </HStack>
    </RadioGroup>
  );
};